import { useState } from "react";
import "../../../../../styles/ComponentsStyles/Setting/Permission/ActAdminVertical.style.css";
import ProfileViewer from "../../../../Universal/Profiles/ProfileViewer.component";
import SearchIcon from "../../../../../assets/Icons/Universal/Search.svg";
import SubAdminVerticalAccessListAccess from "./SubAdminVerticalAccessListAccess.component";

const ActSubAdminVertical = () => {
  const [selectedProfile, setSelectedProfile] = useState("1");
  return (
    <div className=" flex-col flex-1 w-full h-full radius-10 back-white align-left pt-2 pb-2 pl-3 pr-3 g-1">
      <h3 className="t-16 poppins color-black weight-500">
        Here you can add admin as an act admin. They can get all access except
        settings portion.
      </h3>
      <div
        className="flex-col align-left justify-start scroll-y w-full pr-05"
        style={{ height: "28vh" }}
      >
        <div className="verticalAccessActAdminSelectProfileParentContainer">
          {[...Array(10)].map((_, index) => {
            return (
              <div className="verticalAccessActAdminSelectProfileCards">
                <ProfileViewer
                  name={"Md Rejuwanul karim"}
                  _id={"SM4562"}
                  imageHeight={"3rem"}
                  imageWidth={"3rem"}
                  imageSource={"https://randomuser.me/api/portraits/men/53.jpg"}
                  className={"verticalAccessActAdminSelectProfile"}
                />
                <input
                  type="radio"
                  name="profileChanger"
                  value={index.toString()}
                  onChange={(e) => setSelectedProfile(e.target.value)}
                  checked={selectedProfile === index.toString()}
                />
              </div>
            );
          })}
        </div>
      </div>

      <div
        className="overflow-hide p-05 flex-1 flex-col align-left justify-start radius-10  w-full back-white p-1 g-05"
        style={{ border: "2px solid var(--grayBorder)" }}
      >
        <div
          className="flex-col align-left justify-start g-05 w-full "
          style={{ height: "3.4rem" }}
        >
          <div className="searchInputContainer">
            <input
              type="text"
              className="pageHeaderInput"
              placeholder="Type for search"
            />
            <button className="searchBtn">
              <img src={SearchIcon} alt="Search" />
            </button>
          </div>
          <hr color="#b0b0b0" className="w-full" />
        </div>

        <div className="w-full flex-1 scroll-y flex-col align-left justify-start g-2 pr-05">
          <div className="w-full flex-col align-left justify-start g-1">
            <SubAdminVerticalAccessListAccess
              backColor={"#838FD3"}
              parentPath={"Organizational"}
              pathNames={[
                "Management/Dashboard",
                "Management/Structure",
                "Management/Members",
                "Management/Staffs",
                "Management/Activities",
              ]}
            />
            <SubAdminVerticalAccessListAccess
              backColor={"#A5947A"}
              parentPath={"Operational"}
              pathNames={[
                "Academic/Dashboard",
                "Academic/Attendance",
                "Academic/Students",
                "Academic/Teachers",
                "Academic/Exams",
                "Academic/Programs",
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActSubAdminVertical;
